"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartDonut = void 0;
/*
 * Copyright (c) 2023 Discover Financial Services
 * Licensed under MIT License. See License.txt in the project root for license information
 */
const molecule_1 = require("./molecule");
const props_1 = require("../common/props");
/**
 * The Chart Donut molecule.
 * @category Molecules
 */
class ChartDonut extends molecule_1.Molecule {
    constructor(molecules) {
        super("Donut Chart", molecules);
        this.cutoutThickness = new props_1.PropertyRange("Cut out thickness", 0, 100, false, this);
        this.segmentBorderRadius = new props_1.PropertyStringSelectable("Segment Border Radius", false, this, { selectables: ["0px", "4px", "8px", "16px", "24px", "Rounded"] });
        this.spaceBetweenSegments = new props_1.PropertyPixelSelectable("Space between segments", false, this, [2, 4, 8, 16]);
        this.segmentShadow = new props_1.PropertyShadowSelectable("Segment Shadow", false, this);
        this.containerDisplay = new props_1.PropertyBoolean("Container Display", false, this);
        this.containerPadding = new props_1.PropertyPixelSelectable("Container Padding", false, this, [4, 8, 16, 24, 32]);
        this.containerShadow = new props_1.PropertyShadowSelectable("Container Reverse Bevel", false, this);
        this.centerDisplay = new props_1.PropertyBoolean("Center Display", false, this);
    }
    deserialize(obj) {
        if (!obj)
            return;
        super.deserialize(obj);
        this.cutoutThickness.deserialize(obj.cutoutThickness);
        this.segmentBorderRadius.deserialize(obj.segmentBorderRadius);
        this.spaceBetweenSegments.deserialize(obj.spaceBetweenSegments);
        this.segmentShadow.deserialize(obj.segmentShadow);
        this.containerDisplay.deserialize(obj.containerDisplay);
        this.containerPadding.deserialize(obj.containerPadding);
        this.containerShadow.deserialize(obj.containerShadow);
        this.centerDisplay.deserialize(obj.centerDisplay);
    }
    serialize() {
        const obj = {};
        obj.cutoutThickness = this.cutoutThickness.serialize();
        obj.segmentBorderRadius = this.segmentBorderRadius.serialize();
        obj.spaceBetweenSegments = this.spaceBetweenSegments.serialize();
        obj.segmentShadow = this.segmentShadow.serialize();
        obj.containerDisplay = this.containerDisplay.serialize();
        obj.containerPadding = this.containerPadding.serialize();
        obj.containerShadow = this.containerShadow.serialize();
        obj.centerDisplay = this.centerDisplay.serialize();
        return obj;
    }
}
exports.ChartDonut = ChartDonut;
